var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProduct24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "product_24",
    "data-name": "product 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7069",
    "data-name": "Rectangle 7069",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_495",
    "data-name": "Group 495",
    transform: "translate(-0.445 1.889)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_645",
    "data-name": "Path 645",
    d: "M5,9.222,8.016,5l3.016,4.222Z",
    transform: "translate(0 -1.522)",
    fill: "none",
    stroke: "#02466a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_646",
    "data-name": "Path 646",
    d: "M10,5h7.238l3.016,4.222H13.016",
    transform: "translate(-1.984 -1.522)",
    fill: "none",
    stroke: "#02466a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7064",
    "data-name": "Rectangle 7064",
    width: 7.813,
    height: 2.604,
    transform: "translate(7.728 0.997)",
    fill: "none",
    stroke: "#02466a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7065",
    "data-name": "Rectangle 7065",
    width: 5.86,
    height: 11.72,
    transform: "translate(5.124 7.508)",
    fill: "none",
    stroke: "#02466a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7066",
    "data-name": "Rectangle 7066",
    width: 7.162,
    height: 11.72,
    transform: "translate(10.984 7.508)",
    fill: "none",
    stroke: "#02466a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7067",
    "data-name": "Rectangle 7067",
    width: 13.022,
    height: 3.256,
    transform: "translate(5.124 7.508)",
    fill: "none",
    stroke: "#02466a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7068",
    "data-name": "Rectangle 7068",
    width: 13.022,
    height: 3.256,
    transform: "translate(5.124 15.972)",
    fill: "none",
    stroke: "#02466a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduct24);
export default __webpack_public_path__ + "static/media/product-24.bc1de529c49ba19cdca91ab04860e99f.svg";
export { ForwardRef as ReactComponent };